import { useEffect, useRef } from 'react';
import { getAssetTypeList } from './api';

let eventSource = null;
let listeners = new Map();

export function connectEventSource(url) {
    if (eventSource) return eventSource;

    eventSource = new EventSource(url);
    
    eventSource.onmessage = (event) => {
        const data = JSON.parse(event.data);
        // 모든 리스너에게 데이터 전파
        listeners.forEach(callback => callback(data));
    };

    eventSource.onerror = (error) => {
        console.error('EventSource 오류:', error);
    };

    return eventSource;
}

export function subscribeToEventSource(id, callback) {
    listeners.set(id, callback);

    // 구독 해제 함수 반환
    return () => {
        listeners.delete(id);
    };
}

export function disconnectEventSource() {
    if (eventSource) {
        eventSource.close();
        eventSource = null;
        listeners.clear();
    }
}

export function getEventSourceStatus() {
    return {
        isConnected: eventSource !== null,
        listenerCount: listeners.size
    };
}



export function useEventSource(onAssettypSelect) {
    const componentId = useRef(Symbol('eventSource')).current;
    useEffect(() => {
        connectEventSource(getAssetTypeList());
        // 구독
        const unsubscribe = subscribeToEventSource(componentId, onAssettypSelect);

        // 정리
        return unsubscribe;
    }, [onAssettypSelect, componentId]);
}